import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { ToastService } from '@services/common/toast.service';
import { UserAction, UserStatus } from '@state/user.state';
import { CognitoAuthenticationService } from 'app/auth/service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfigService } from 'app/app-config.service';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    standalone: false,
})
export class TermsComponent implements OnInit {
    @Output() closeModal = new EventEmitter<boolean>();
    termsUrl: string = 'https://d-carbonize.eu/data-privacy';
    termsAccepted = false;
    /** Accept was pressed: shows the box is required while it stays unticked. */
    submitted = false;
    loading = false;
    public mainColor: string;

    constructor(
        private readonly cognitoAuthenticationService: CognitoAuthenticationService,
        private configService: ConfigService,
        private readonly store: Store,
        private readonly toastService: ToastService,
        private readonly ref: DynamicDialogRef,
        private readonly translateService: CustomTranslateService,
    ) {
        this.mainColor = this.configService.brand.primary;
    }

    closeDialog(termsAccepted?: boolean) {
        this.ref.close(termsAccepted ?? this.termsAccepted);
    }
    ngOnInit(): void {
        this.translateService.onLangChange.subscribe((ev) => {
            if (ev.lang === 'fr') {
                this.termsUrl = 'https://d-carbonize.eu/fr/politique-de-confidentialite/';
            } else {
                this.termsUrl = 'https://d-carbonize.eu/data-privacy';
            }
        });
    }
    public onSubmit(): void {
        this.submitted = true;
        if (this.termsAccepted) {
            this.loading = true;
            this.cognitoAuthenticationService.acceptTerms(1).subscribe({
                next: (res) => {
                    if (res === 'SUCCESS') {
                        this.store.dispatch(new UserAction.UpdateUserStatus(UserStatus.TERMS));
                        this.loading = false;
                    } else {
                        this.store.dispatch(new UserAction.UpdateUserStatus(UserStatus.NONE));
                        this.toastService.showError({ details: 'common.error' });
                        this.loading = false;
                    }
                    this.closeDialog();
                },
                // The dialog stays open so the user can accept again
                error: () => {
                    this.toastService.showError({ details: 'common.error' });
                    this.loading = false;
                },
            });
        }
    }
}
